module.exports = __webpack_public_path__ + "img/3_7_1.c8bdc063.jpg";